<template>
  <header id="header">
    <div class="header-content">
      <router-link to="/" id="header-logo">
        <img
          src="../../assets/logo.png"
          alt="呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call"
        />
        <p class="logo-title">
          呼び出しベル・チャイム <br />
          （ワイヤレス）<br />
          の専門店ならB-Call
        </p>
      </router-link>
    </div>

    <slide right noOverlay>
      <router-link
        v-for="(item, index) in items"
        :key="index"
        v-bind:to="item.path"
        exact
      >
        <span>{{ item.title }}</span>
      </router-link>
    </slide>
  </header>
</template>

<script>
export default {
  name: 'SpHeaderMenu',
  data() {
    return {
      items: [
        { title: 'HOME', path: '/' },
        { title: '商品一覧', path: '/products' },
        { title: '商品の選び方', path: '/choice/purpose' },
        { title: 'よくあるご質問', path: '/faq' },
        { title: 'ご購入方法', path: '/guide' },
        { title: 'デモ機貸出し方法', path: '/rental' },
        { title: 'お知らせ', path: '/news' },
        { title: 'お役立ちコラム', path: '/columns' },
        { title: '会社案内', path: '/company' },
      ],
    }
  },
}
</script>

<style scoped>
header {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;

  width: 100%;
  height: 80px;
  padding-top: 16px;

  border-bottom: 1px solid rgb(22, 141, 211);
  background-color: rgb(220, 238, 254);
}

.header-content {
  margin: 10px 92px 0 auto;
}

#header-logo {
  font-size: 13px;

  display: flex;
  align-items: center;

  text-decoration: none;

  color: #4d4d4d;
}

#header-logo img {
  height: 45px;
  margin-left: auto;
}

.logo-title {
  margin-right: auto;
  margin-left: 16px;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 13px;
  color: #4d4d4d;
  font-weight: normal;
  line-height: 16px;
}

.logo-title p {
  line-height: 16px;

  margin: 0;
}
</style>

<style>
.bm-menu {
  font-size: 12px;
  font-weight: bold;
  line-height: 25px;

  margin: auto;

  list-style: none;

  background-color: rgb(26, 87, 167);
}

.bm-menu a {
  text-decoration: none;

  color: #eee;
}

.bm-burger-button {
  top: 36px;
  left: 20px;
}

.bm-burger-bars {
  background-color: rgb(26, 87, 167);
}
</style>



// WEBPACK FOOTER //
// src/components/modules/SpHeaderMenu.vue